/* eslint-disable no-unused-vars */
import clsx from "clsx";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import * as React from "react";
/* eslint-enable no-unused-vars */

class MTablePaginationInner extends React.Component {
  handleFirstPageButtonClick = event => {
    this.props.setCurrentPage(0);
  };

  handleBackButtonClick = event => {
    this.props.setCurrentPage(page => page - 1);
  };

  handleNextButtonClick = event => {
    this.props.setCurrentPage(page => page + 1);
  };

  handleLastPageButtonClick = event => {
    this.props.onChangePage(
      event,
      Math.max(
        0,
        Math.ceil(this.props.totalQuantity / this.props.rowsPerPage) - 1
      )
    );
  };

  render() {
    const {
      classes,
      currentPage,
      totalQuantity,
      rowsPerPage,
      showFirstLastPageButtons,
      editing,
      isNextButtonDisabled = false,
      loadingProjects
    } = this.props;
    const localization = {
      ...MTablePaginationInner.defaultProps.localization,
      ...this.props.localization
    };

    return (
      <>
        <span></span>
        <div className={clsx(classes.root, classes.pagination)}>
          {!!totalQuantity && (
            <Typography
              variant="caption"
              className={classes.pageCountText}
              data-cy="projects-pageState"
            >
              {localization.labelDisplayedRows
                .replace("{from}", currentPage * rowsPerPage + 1)
                .replace(
                  "{to}",
                  Math.min((currentPage + 1) * rowsPerPage, totalQuantity)
                )
                .replace("{count}", totalQuantity)}
            </Typography>
          )}
          {showFirstLastPageButtons && (
            <Tooltip title={localization.firstTooltip}>
              <span>
                <IconButton
                  onClick={this.props.handleFirstPageButtonClick}
                  disabled={currentPage === 0}
                  aria-label={localization.firstAriaLabel}
                >
                  <this.props.icons.FirstPage />
                </IconButton>
              </span>
            </Tooltip>
          )}
          <Tooltip title={localization.previousTooltip}>
            <span>
              <IconButton
                onClick={e => {
                  this.props.setSelected([]);
                  this.handleBackButtonClick(e);
                }}
                data-cy="projects-nextPage"
                className={classes.iconButton}
                disabled={currentPage === 0 || editing || loadingProjects}
                aria-label={localization.previousAriaLabel}
              >
                <this.props.icons.PreviousPage />
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip title={localization.nextTooltip}>
            <span>
              <IconButton
                onClick={e => {
                  this.props.setSelected([]);
                  this.handleNextButtonClick(e);
                }}
                data-cy="projects-prevPage"
                className={classes.iconButton}
                disabled={
                  currentPage >= Math.ceil(totalQuantity / rowsPerPage) - 1 ||
                  editing ||
                  loadingProjects ||
                  isNextButtonDisabled
                }
                aria-label={localization.nextAriaLabel}
              >
                <this.props.icons.NextPage />
              </IconButton>
            </span>
          </Tooltip>
          {showFirstLastPageButtons && (
            <Tooltip title={localization.lastTooltip}>
              <span>
                <IconButton
                  onClick={this.props.handleLastPageButtonClick}
                  disabled={
                    currentPage >= Math.ceil(totalQuantity / rowsPerPage) - 1
                  }
                  aria-label={localization.lastAriaLabel}
                >
                  <this.props.icons.LastPage />
                </IconButton>
              </span>
            </Tooltip>
          )}
        </div>
      </>
    );
  }
}

MTablePaginationInner.defaultProps = {
  showFirstLastPageButtons: true,
  localization: {
    firstTooltip: "First Page",
    previousTooltip: "Previous Page",
    nextTooltip: "Next Page",
    lastTooltip: "Last Page",
    labelDisplayedRows: "{from}-{to} of {count}",
    labelRowsPerPage: "Rows per page:"
  }
};

export default MTablePaginationInner;
